<template>
  <div class="manager">
    <el-container>
      <el-header height="48px" v-if="!$store.state.isInIframe">
        <v-logo></v-logo>
        <span>
          {{ `欢迎！${origin_userInfo.name}` }}
          <el-button @click="handleLogOut" size="mini">退出</el-button>
        </span>
      </el-header>
      <el-main>
        <projects-list :user_id="user_id"></projects-list>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import VLogo from './commonviews/VLogo.vue';
import ProjectsList from './managerviews/ProjectsList.vue';
import { logout } from '../login/conf/commonFunc.js';
import { registerUser } from '../common/commons';
// import jq from 'jquery';
// @ is an alias to /src
export default {
  name: 'Manager',
  components: { VLogo, ProjectsList },
  data() {
    return {
      origin_userInfo: {
        name: '',
      },
      // bbdas项目用户id
      user_id: '',
      isLogin: false,
    };
  },
  created() {
    //if (!this.$store.state.isInIframe) {
    this.checkLocalUserInfo();
    // }
  },
  mounted() {
    let _this = this;
    if (this.$store.state.isInIframe) {
      window.onload = () => {
        window.addEventListener(
          'message',
          function (e) {
            if (e.data.row_id) {
              localStorage.setItem('origin_userInfo', JSON.stringify(e.data));
              _this.checkLocalUserInfo();
            }
          },
          false,
        );
      };
    }
  },
  beforeUnmount() {},
  methods: {
    handleLogOut() {
      logout();
    },
    // 检查本地localstorage存入的用户信息
    checkLocalUserInfo() {
      // 获取本地的用户信息
      let origin_userInfo = window.localStorage.getItem('origin_userInfo');
      // 检查本地登录原始用户信息是否存在
      if (origin_userInfo) {
        this.origin_userInfo = JSON.parse(origin_userInfo);
        console.log('origin_userInfo', this.origin_userInfo);
        // 状态改为已登录
        this.isLogin = true;
        // 注册用户拿到Row_id
        this.registUseru();
      } else {
        // 没有用户信息 就去登录
        // this.redirectToLogin();
      }
    },
    registUseru() {
      registerUser({
        data: {
          user_name: this.origin_userInfo.name,
          user_account: this.origin_userInfo.row_id + '',
        },
      }).then(res => {
        console.log(res, '1111111111');
        localStorage.setItem('user_key', res?.data?.user_key);
        console.log('user_key', localStorage.getItem('user_key'));
        if (res?.data?.row_id) {
          this.user_id = res.data.row_id;
          console.log('user_id', this.user_id);
        }
      });
    },
    // goLogOut() {
    //   function getUrlParam(name) {
    //     let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    //     let r = window.location.search.substr(1).match(reg);
    //     if (r != null) return unescape(r[2]);
    //     return null;
    //   }
    //   debugger;
    //   let url = window.document.location.href;
    //   var login_page = getUrlParam('login_page');
    //   var paramStr = '';
    //   if (login_page && login_page != '') {
    //     paramStr += 'login_page=' + login_page;
    //   }
    //   var username = getUrlParam('u');
    //   if (username && username != '') {
    //     if (paramStr) {
    //       paramStr += '&';
    //     }
    //     paramStr += 'username=' + username;
    //   }
    //   var password = getUrlParam('p');
    //   if (password && password != '') {
    //     if (paramStr) {
    //       paramStr += '&';
    //     }
    //     paramStr += 'password=' + password;
    //   }
    //   var logo = getUrlParam('l');
    //   if (logo && logo != '') {
    //     if (paramStr) {
    //       paramStr += '&';
    //     }
    //     paramStr += 'logo=' + logo;
    //   }
    //   var title = getUrlParam('t');
    //   if (title && title != '') {
    //     if (paramStr) {
    //       paramStr += '&';
    //     }
    //     paramStr += 'title=' + title;
    //   }
    //   let pathName = this.$route.href;
    //   let pos = url.indexOf(pathName);
    //   let redirectUrl = url.substring(0, pos);
    //   redirectUrl = redirectUrl.split('?')[0] + '?' + paramStr;
    //   window.localStorage.removeItem('logOut');
    //   window.location = this.$Api.logOut + 'redirect_uri=' + redirectUrl;
    // },

    // // 重定向到登录页面
    // redirectToLogin(force = false) {
    //   function getUrlParam(name) {
    //     let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    //     let r = window.location.search.substr(1).match(reg);
    //     if (r != null) return unescape(r[2]);
    //     return null;
    //   }
    //   let url = window.document.location.href;
    //   var login_page = getUrlParam('login_page');
    //   var paramStr = '';
    //   if (login_page && login_page != '') {
    //     paramStr += 'login_page=' + login_page;
    //   }
    //   var username = getUrlParam('u');
    //   if (username && username != '') {
    //     if (paramStr) {
    //       paramStr += '&';
    //     }
    //     paramStr += 'username=' + username;
    //   }
    //   var password = getUrlParam('p');
    //   if (password && password != '') {
    //     if (paramStr) {
    //       paramStr += '&';
    //     }
    //     paramStr += 'password=' + password;
    //   }
    //   var logo = getUrlParam('l');
    //   if (logo && logo != '') {
    //     if (paramStr) {
    //       paramStr += '&';
    //     }
    //     paramStr += 'logo=' + logo;
    //   }
    //   var title = getUrlParam('t');
    //   if (title && title != '') {
    //     if (paramStr) {
    //       paramStr += '&';
    //     }
    //     paramStr += 'title=' + title;
    //   }
    //   let pathName = this.$route.href;
    //   let pos = url.indexOf(pathName);
    //   let redirectUrl = url.substring(0, pos); //encodeURIComponent(document.URL);
    //   redirectUrl = redirectUrl.split('?')[0] + '?' + paramStr;
    //   redirectUrl = encodeURIComponent(redirectUrl);
    //   let code = getUrlParam('code');
    //   console.log(code);
    //   if (!code || code == '' || force) {
    //     window.location =
    //       this.$Api.logIn + 'client_id=appid&redirect_uri=' + redirectUrl + '&response_type=code&scope=read';
    //   } else {
    //     this.getUserInfo();
    //   }
    // },
    // // 通过 Url 里的code 获取用户信息
    // getUserInfo() {
    //   function getUrlParam(name) {
    //     let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    //     let r = window.location.search.substr(1).match(reg);
    //     if (r != null) return unescape(r[2]);
    //     return null;
    //   }

    //   let url = window.document.location.href;
    //   var login_page = getUrlParam('login_page');
    //   var paramStr = '';
    //   if (login_page && login_page != '') {
    //     paramStr += 'login_page=' + login_page;
    //   }
    //   var username = getUrlParam('u');
    //   if (username && username != '') {
    //     if (paramStr) {
    //       paramStr += '&';
    //     }
    //     paramStr += 'username=' + username;
    //   }
    //   var password = getUrlParam('p');
    //   if (password && password != '') {
    //     if (paramStr) {
    //       paramStr += '&';
    //     }
    //     paramStr += 'password=' + password;
    //   }
    //   var logo = getUrlParam('l');
    //   if (logo && logo != '') {
    //     if (paramStr) {
    //       paramStr += '&';
    //     }
    //     paramStr += 'logo=' + logo;
    //   }
    //   var title = getUrlParam('t');
    //   if (title && title != '') {
    //     if (paramStr) {
    //       paramStr += '&';
    //     }
    //     paramStr += 'title=' + title;
    //   }
    //   let pathName = this.$route.href;
    //   let pos = url.indexOf(pathName);
    //   let redirectUrl = url.substring(0, pos);
    //   redirectUrl = redirectUrl.split('?')[0] + '?' + paramStr;
    //   redirectUrl = encodeURIComponent(redirectUrl);
    //   let sendFormData = new FormData();
    //   let code = getUrlParam('code');
    //   sendFormData.append('code', code);
    //   sendFormData.append('redirect_uri', redirectUrl);

    //   this.axios({
    //     method: 'POST',
    //     url: this.$Api.getUserInfo,
    //     headers: {
    //       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    //     },
    //     data: qs.stringify({
    //       code: code,
    //       redirect_uri: redirectUrl,
    //     }),
    //   }).then(response => {
    //     if (response?.data?.data) {
    //       console.log('原始用户信息 origin_userInfo', response.data.data);
    //       this.origin_userInfo = response.data.data;
    //       // 存入本地localStorage
    //       window.localStorage.setItem('origin_userInfo', JSON.stringify(response.data.data));
    //       this.registUser();
    //       this.$ElMessage.success('登录成功！');
    //     } else if (this.isLogin === false) {
    //       this.$ElMessage.warning('登录失败！正在重试...');
    //       // 传入参数true强制跳转到登录页面 重新获取code
    //       this.redirectToLogin(true);
    //     }
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
.manager {
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  .el-container {
    width: 100%;
    height: 100%;

    .el-header {
      display: flex;
      align-items: center;
      background-color: #282936;
      box-sizing: border-box;
      border-bottom: 1px solid #131313;
      justify-content: space-between;

      .v-logo {
        color: #909399;
      }

      span {
        color: whitesmoke;
        .el-button {
          // padding: 0 10px;
          margin-left: 10px;
          border-radius: 5px;
          color: #b6b8cc;
          border: 0;
          background: #454863;
          &:hover {
            background: linear-gradient(143deg, #335ae9, #6f6ff5);
            color: white;
          }
        }

        .el-icon-switch-button {
          padding-right: 4px;
        }
      }
    }

    .el-main {
      background: #0f1016;
      padding: 0;
      color: white;
      &::-webkit-scrollbar-thumb {
        background: #191e29 !important;
        width: 4px !important;
        height: 3px !important;
      }
      &::-webkit-scrollbar {
        width: 4px !important;
        height: 3px !important;
      }
      &::-webkit-scrollbar-track {
        background: #43455800;
      }
    }
  }
}
</style>
